export default {
    en: {
        PROFILE_MENU_LABEL: 'Profile menu',
        PROFILE_MENU_VIEW_REPORT_CARD: 'View Mission Log',
        PROFILE_MENU_VIEW_COURSEWARE: 'View Courseware',
        PROFILE_MENU_RESET_PROGRESS: 'Reset Progress',
        PROFILE_MENU_KNOWLEDGE_BASE: 'Knowledge Base',
        PROFILE_MENU_CONTACT_SUPPORT: 'Contact Support',
        PROFILE_MENU_LOGOUT: 'Log out',
        PROFILE_MENU_OPENS_IN_NEW_TAB: 'Opens in a new tab.',
    }
};
